<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-lg-2 col-6">
        <div class="row">
          <div class="col-12">
            <b-form-group v-slot="{ ariaDescribedby }">
              <b-form-radio-group id="btn-radios-3" @change="SelectDate" v-model="selected" :options="['امروز', 'ماه جاری', 'امسال']" :aria-describedby="ariaDescribedby" name="radio-btn-stacked" buttons stacked></b-form-radio-group>
            </b-form-group>
          </div>
          <div class="col-12 pt-4"></div>
        </div>
      </div>
      <div class="col-lg-10 text-center">
        <div v-if="dist.length <= 1" class="w-100">
          <h5>در این بازه تیکتی ثبت نشده است</h5>
        </div>
        <div v-if="dist.length > 1" dir="ltr">
          <apexchart v-if="render" :height="350" :options="ApexChartOptions" :series="series"></apexchart>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      render: true,
      selected: 'ماه جاری',
      ApexChartOptions: {
        chart: {
          type: 'bar',
          height: 350,
          stacked: true,
        },
        plotOptions: {
          bar: {
            horizontal: true,
            barHeight: '33%',
          },
        },
        stroke: {
          width: 0,
          colors: ['#fff'],
        },
        title: {
          text: '',
        },
        xaxis: {
          categories: [],
          labels: {
            formatter: function (val) {
              return val
            },
          },
        },
        yaxis: {
          title: {
            text: undefined,
          },
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return val
            },
          },
        },
        fill: {
          opacity: 1,
        },
        legend: {
          position: 'top',
          horizontalAlign: 'left',
          offsetX: 40,
        },
        colors: ['#5CB0FF', '#4CAF50', '#FDA700', '#fd397a', '#21AE89', '#5578eb', '#657685', '#f56905', '#e59595', '#000'],
      },
      dist: [],
      series: [
        {
          name: 'باز',
          data: [],
          Id: 1791,
        },
        {
          name: 'پاسخ داده شده',
          data: [],
          Id: 1792,
        },
        {
          name: 'پاسخ مشتري',
          data: [],
          Id: 1793,
        },
        {
          name: 'در حال رسیدگی',
          data: [],
          Id: 1794,
        },
        {
          name: 'در حال انجام',
          data: [],
          Id: 1795,
        },
        {
          name: 'بسته شده',
          data: [],
          Id: 1796,
        },
        {
          name: 'تست',
          data: [],
          Id: 1797,
        },
        {
          name: 'تحويل نسخه',
          data: [],
          Id: 1798,
        },
        {
          name: 'بایگانی ',
          data: [],
          Id: 1842,
        },
        {
          name: 'نگه داشته شده',
          data: [],
          Id: 1841,
        },
      ],
    }
  },
  methods: {
    SelectDate() {
      if (this.selected == 'امروز') var selector = 1
      else if (this.selected == 'ماه جاری') var selector = 2
      else if (this.selected == 'امسال') var selector = 3
      this.getData(selector)
    },
    getData(selector) {
      this.series.forEach((element) => (element.data = []))
      var DataAxios = { Method: 'POST', Action: 'Ticket/TicketDistribution', ArryfildValue: { dateId: selector, tblUserId: 1 } }
      this.$PostData(DataAxios)
        .then((resutl) => {
          this.dist = resutl.dist
        })
        .finally(() => {
          this.render = false

          if (this.dist.length > 0) {
            this.dist.forEach((element) => {
              var check = element.namFam == null ? 'وضعیت نامشخص' : element.namFam
              if (this.ApexChartOptions.xaxis.categories.indexOf(check) == -1) {
                this.ApexChartOptions.xaxis.categories.push(check)
              }
            })
            this.ApexChartOptions.xaxis.categories.forEach((cat) => {
              var temp = this.dist.filter((x) => x.namFam == cat)
              this.series.forEach((es) => {
                //  console.log(temp.filter((t) => t.tblComboGrpId41 == es.Id)[0]?temp.filter((t) => t.tblComboGrpId41 == es.Id)[0].count:0 )
                es.data.push(temp.filter((t) => t.tblComboGrpId41 == es.Id)[0] ? temp.filter((t) => t.tblComboGrpId41 == es.Id)[0].count : 0)
              })
            })

            this.$nextTick(() => {
              this.render = true
              this.render = true
            })
          }
        })
    },
  },
  created() {
    this.getData(2)
  },
}
</script>
<style>
.apexcharts-menu-item {
  color: var(--sidebar-color-item) !important;
  background: var(--sidebar-bg-color) !important;
  border-color: var(--sidebar-bg-color) !important;
}
.apexcharts-menu.apexcharts-menu-open {
  background: var(--sidebar-bg-color) !important;
}
</style>
